import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink pb-24 pt-14 text-ivory md:pb-14" data-id="element-108" data-mp="32wd2qgad7ltj">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-109" data-mp="3ggar7wn6mf5z">
        <p className="font-serif text-lg tracking-[0.08em] text-gold" data-id="element-110" data-mp="32o4bucrusc7l">
          MASTER PLAN 15
        </p>

        <p className="measure mt-4 text-sm leading-relaxed text-ivory/60" data-id="element-111" data-mp="36oxzr65apr0h">
          El sistema completo para las organizadoras que se niegan a improvisar
          el día más importante de la vida de una quinceañera.
        </p>

        <nav aria-label="Enlaces del pie de página" className="mt-8 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-ivory/70" data-id="element-112" data-mp="37fth3568s26">
          <a href="#" className="transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-113" data-mp="3qd6u9muba935">
            Términos y condiciones
          </a>
          <span aria-hidden="true" className="text-ivory/25" data-id="element-114" data-mp="2eyjprl0ekyu3">
            ·
          </span>
          <a href="#" className="transition-colors hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-115" data-mp="3l8qv40rs6dpv">
            Política de privacidad
          </a>
        </nav>

        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-ivory/40" data-id="element-116" data-mp="3v9b1fhu5q8ey">
          © 2026 Master Plan 15. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}